module.exports = __webpack_public_path__ + "static/media/034.e346c640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/034.jpg
// module id = 541
// module chunks = 0